var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.39 5.105a3.007 3.007 0 0 1 2.116 2.116c.514 1.878.494 5.792.494 5.792s0 3.895-.494 5.773A3.007 3.007 0 0 1 21.39 20.9c-1.878.494-9.39.494-9.39.494s-7.493 0-9.39-.514a3.007 3.007 0 0 1-2.116-2.115C0 16.908 0 12.993 0 12.993S0 9.1.494 7.221A3.069 3.069 0 0 1 2.61 5.086C4.488 4.59 12 4.59 12 4.59s7.512 0 9.39.514Zm-5.535 7.888-6.247 3.598V9.395l6.247 3.598Z",
    fill: "currentColor"
  })));
};
export default SvgYoutube;